<template>
    
    <form @submit.prevent="submitForm">
        
        <div class="col-md-12" style="text-align: left;">
            <div class="col-md-2"> 
                <label for="">Servicio</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-12">
                <textarea name="" id="" rows="10" class="form-control" v-model="servicio"></textarea>
            </div>
        </div>
        <div class="py-3 col-md-12" style="text-align: left;">
            <div class="col-md-2"> 
                <label for="">Alcance</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-12">
                <textarea name="" id="" rows="10" class="form-control" v-model="alcance"></textarea>
            </div>
        </div>
        <div class="py-3 col-md-12" style="text-align: left;">
            <div class="col-md-2"> 
                <label for="">Procedimiento</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-12">
                <textarea name="" id="" rows="10" class="form-control" v-model="procedimiento"></textarea>
            </div>
        </div>
        <div class="py-3 col-md-12" style="text-align: left;">
            <div class="col-md-2"> 
                <label for="">Tecnica</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-12">
                <textarea name="" id="" rows="10" class="form-control" v-model="tecnica"></textarea>
            </div>
        </div>
        <div class="py-3 form-group row col-md-12">
            <div class="col-md-3" style="text-align: justify;">
                <label for="">Actividad</label>
            </div>
            <div class="col-md-2">
                <label for="">Fecha Planeada</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-2">
                <label for="">Fecha Cumplida</label><span class="is-invalid">*</span>
    
               
            </div>
    
            <div class="col-md-5" style="text-align: justify;">
                <label for="">Observaciones</label>
            </div>
        </div>
        <!-- Recorre el array de preguntas dinámicamente -->
        <div v-for="(pregunta, index) in preguntas" :key="index" class="py-3 form-group row col-md-12" style="text-align: justify;">
          <div class="col-md-3">
            <label>{{ pregunta.actividad }}</label>
          </div>
          <div class="col-md-2">
            <input type="date" v-model="pregunta.fecha_planeada" class="form-control" />
              
          </div>
          <div class="col-md-2">
            <input type="date" v-model="pregunta.fecha_cumplida" class="form-control" />
              
          </div>
          <div class="col-md-5">
            <textarea class="form-control" v-model="pregunta.observaciones"></textarea>
          </div>
        </div>
        <button v-if="this.datos == true" type="submit" class="btn btn-primary">Actualizar</button>
        <button v-else type="submit" class="btn btn-primary">Enviar</button>
    </form>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                preguntas: [
                    {
                        actividad: 'Solicitud de documentos: Resolutivo, Memoria Técnica y anexos',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Recepción de documentos: Resolutivo, Memoria Técnica y anexos',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Análisis documental de evidencias por la Unidad de Inspección',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Aviso de Información faltante',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Recepción de Información faltante',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Confirmación de pago de finiquito',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Acuerdo para agendar visita al sitio',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Visita de inspección al sitio',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Realización de acciones correctivas (en caso de haber hallazgos)',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    },
                    {
                        actividad: 'Cierre de hallazgos',
                        fecha_planeada:    '',
                        fecha_cumplida: '',
                        observaciones: '' 
                    }

                ],
                datos:false,
                servicio:'',
                alcance:"",
                procedimiento:"",
                tecnica:''
            }
        },
        created() {
            this.getPlanInspecciones();
        },
        methods: {
            getPlanInspecciones() {
                const id = localStorage.getItem('idcotizacion');
                axios.post(this.$rutaServer+'consultarPlanInspecciones',{idcotizacion:id})
                    .then(response => {
                    if(response.data.length > 0){
                        this.datos = true;

                        // Suponiendo que las inspecciones tienen los campos que coinciden con el formato de las preguntas
                    this.preguntas = response.data.map(inspeccion => ({
                        /*servicio: inspeccion.servicio,
                        alcance: inspeccion.alcance,
                        procedimiento: inspeccion.procedimiento,
                        tecnica: inspeccion.tecnica,*/
                        actividad: inspeccion.actividad,
                        fecha_planeada: inspeccion.fecha_planeada,
                        fecha_cumplida: inspeccion.fecha_cumplida,
                        observaciones: inspeccion.observaciones
                    }));

                    
                        this.servicio =  response.data[0].servicio;
                        this.alcance =  response.data[0].alcance;
                        this.procedimiento = response.data[0].procedimiento;
                        this.tecnica =  response.data[0].tecnica;
                    
                    }
                    
                    })
                    .catch(error => {
                    console.error("Error al obtener las inspecciones:", error);
                    });
            },
            async submitForm() {
                try {
                    // Envía todo el arreglo de preguntas al backend
                    const id = localStorage.getItem('idcotizacion');
                    this.idcotizacion = id;
                    const response = await axios.post(this.$rutaServer+'guardarDatosPlanInspeccion', {
                        preguntas: this.preguntas,
                        idcotizacion: this.idcotizacion,
                        servicio:this.servicio,
                        alcance:this.alcance,
                        procedimiento:this.procedimiento,
                        tecnica:this.tecnica
                    });
                    if(response.status == 200){
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                    }
                    else{
                        Swal.fire('¡Error!', 'Ocurrio un error complete campos requeridos', 'error');
                    }
                
                } catch (error) {
                    Swal.fire('¡Error!', 'Ocurrio un error complete campos requeridos', 'error');
                console.error('Error al enviar los datos:', error);
                }
            }
        },
    }
</script>
<style>
    .is-invalid {
        color: red;
    }
</style>